export default __webpack_public_path__ + "static/media/mock_ava.848e97ad.png";